/*
 * Hearth & Oak bundle offer selector (snippets/ho-bundle.liquid)
 *
 * - Single-pair offers: Impulse's own product form and AJAX cart handle the purchase.
 * - Multi-pair offers: every pair's selected variant is added at its normal price in one
 *   /cart/add.js request. Any free pair comes from a Shopify automatic discount; after adding,
 *   the real cart is checked and the customer is told if no discount was applied.
 */
(function () {
  'use strict';

  if (window.HOBundle) {
    window.HOBundle.initAll();
    return;
  }

  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  function money(cents) {
    try {
      if (window.theme && theme.Currency && theme.settings && theme.settings.moneyFormat) {
        return theme.Currency.formatMoney(cents, theme.settings.moneyFormat);
      }
    } catch (e) { /* fall through */ }
    return '$' + (cents / 100).toFixed(2);
  }

  function fill(template, values) {
    return (template || '').replace(/\{(\w+)\}/g, function (m, key) {
      return values[key] !== undefined ? values[key] : m;
    });
  }

  function Bundle(el) {
    this.el = el;
    this.data = JSON.parse(el.querySelector('[data-ho-bundle-json]').textContent);
    this.section = el.closest('[data-section-type="product"]') || el.closest('.product-section') || document.body;
    this.form = this.section.querySelector('form[action*="/cart/add"]');
    if (!this.form) return;

    this.btn = this.form.querySelector('[type="submit"][name="add"]') || this.form.querySelector('[type="submit"]');
    this.btnText = this.btn && this.btn.querySelector('[data-add-to-cart-text]');
    this.summary = el.querySelector('[data-ho-bundle-summary]');
    this.message = el.querySelector('[data-ho-bundle-message]');
    this.loading = false;
    this.pairOneTouched = false;
    this.originalDefaultText = this.btnText ? this.btnText.dataset.defaultText : '';

    this.bind();
    this.syncPairOneToNative();
    this.update();
    el.setAttribute('data-ho-ready', '');
  }

  Bundle.prototype = {
    bind: function () {
      var self = this;

      this.el.querySelectorAll('[data-ho-offer-radio]').forEach(function (radio) {
        radio.addEventListener('change', function () {
          self.hideMessage();
          self.update();
        });
      });

      this.el.querySelectorAll('.ho-bundle__select, .ho-bundle__swatch-input').forEach(function (control) {
        control.addEventListener('change', function () {
          var pairEl = control.closest('[data-ho-pair]');
          if (pairEl && pairEl.dataset.hoPair === '1') self.pairOneTouched = true;
          if (pairEl) self.reconcile(pairEl, parseInt(control.dataset.optionIndex, 10));
          self.hideMessage();
          self.update();
        });
      });

      // Impulse rewrites the button on variant change; re-apply bundle state afterwards.
      this.section.addEventListener('variantChange', function () {
        setTimeout(function () {
          self.syncPairOneToNative();
          self.update();
        }, 0);
      });

      // Capture phase on an ancestor runs before Impulse's own submit listener on the form.
      this.section.addEventListener('submit', function (evt) {
        if (evt.target !== self.form) return;
        var offer = self.currentOffer();
        if (!offer || offer.pairs <= 1) return; // single pair: normal Impulse flow
        evt.preventDefault();
        evt.stopPropagation();
        self.addBundle(offer);
      }, true);
    },

    currentOfferNumber: function () {
      var checked = this.el.querySelector('[data-ho-offer-radio]:checked');
      return checked ? checked.value : null;
    },

    currentOffer: function () {
      var n = this.currentOfferNumber();
      return n ? this.data.offers[n] : null;
    },

    nativeVariant: function () {
      var input = this.form.querySelector('[name="id"]');
      if (!input) return null;
      var id = parseInt(input.value, 10);
      return this.data.variants.find(function (v) { return v.id === id; }) || null;
    },

    findVariant: function (values) {
      return this.data.variants.find(function (v) {
        return v.options.every(function (opt, i) { return opt === values[i]; });
      }) || null;
    },

    // A pair's option controls, by option index: a <select> or a swatch radio group.
    pairControls: function (pairEl) {
      var controls = {};
      pairEl.querySelectorAll('.ho-bundle__select').forEach(function (select) {
        controls[select.dataset.optionIndex] = { type: 'select', el: select };
      });
      pairEl.querySelectorAll('[data-ho-swatches]').forEach(function (group) {
        controls[group.dataset.optionIndex] = { type: 'swatch', el: group };
      });
      return controls;
    },

    readValues: function (pairEl) {
      var values = [];
      var controls = this.pairControls(pairEl);
      Object.keys(controls).forEach(function (index) {
        var c = controls[index];
        if (c.type === 'select') {
          values[index] = c.el.value;
        } else {
          var checked = c.el.querySelector('.ho-bundle__swatch-input:checked');
          values[index] = checked ? checked.value : null;
        }
      });
      return values;
    },

    writeValue: function (pairEl, index, value) {
      var c = this.pairControls(pairEl)[index];
      if (!c) return;
      if (c.type === 'select') {
        c.el.value = value;
      } else {
        c.el.querySelectorAll('.ho-bundle__swatch-input').forEach(function (input) {
          input.checked = input.value === value;
        });
      }
    },

    // After one option changes, keep the pair on a real, available variant:
    // keep the changed value and as many of the other choices as possible.
    reconcile: function (pairEl, changedIndex) {
      var values = this.readValues(pairEl);
      var current = this.findVariant(values);
      if (current && current.available) return;
      var self = this;
      var best = null;
      var bestScore = -1;
      this.data.variants.forEach(function (v) {
        if (!v.available || v.options[changedIndex] !== values[changedIndex]) return;
        var score = v.options.filter(function (opt, i) { return opt === values[i]; }).length;
        if (score > bestScore) { best = v; bestScore = score; }
      });
      if (!best) return; // nothing available with this value: validation explains it
      best.options.forEach(function (opt, i) { self.writeValue(pairEl, i, opt); });
    },

    // Default pair 1 to whatever the shopper chose in the main picker (until they change it here).
    syncPairOneToNative: function () {
      if (this.pairOneTouched) return;
      var variant = this.nativeVariant();
      if (!variant) return;
      var self = this;
      this.el.querySelectorAll('[data-ho-pair="1"]').forEach(function (pair) {
        variant.options.forEach(function (value, i) { self.writeValue(pair, i, value); });
      });
    },

    readPairs: function (offerEl) {
      var self = this;
      var pairs = [];
      var pairEls = offerEl.querySelectorAll('[data-ho-pair]');

      if (!pairEls.length) {
        // Product without options: every pair is the single default variant.
        var only = this.data.variants[0];
        var count = this.data.offers[offerEl.dataset.hoOffer].pairs;
        for (var i = 0; i < count; i++) pairs.push({ el: null, variant: only });
        return pairs;
      }

      pairEls.forEach(function (pairEl) {
        var values = self.readValues(pairEl);
        self.markUnavailableValues(pairEl, values);
        pairs.push({ el: pairEl, variant: self.findVariant(values) });
      });
      return pairs;
    },

    // Mark option values that can't be bought with the pair's other current choices.
    markUnavailableValues: function (pairEl, values) {
      var self = this;
      var isAvailable = function (index, value) {
        var test = values.slice();
        test[index] = value;
        var v = self.findVariant(test);
        return !!(v && v.available);
      };
      pairEl.querySelectorAll('.ho-bundle__select').forEach(function (select) {
        var index = parseInt(select.dataset.optionIndex, 10);
        Array.prototype.forEach.call(select.options, function (option) {
          if (!option.dataset.label) option.dataset.label = option.textContent;
          var available = isAvailable(index, option.value);
          option.textContent = available ? option.dataset.label : option.dataset.label + ' — ' + self.data.strings.soldOut;
          // The current choice stays selectable so the pair's error message can explain it.
          option.disabled = !available && option.value !== select.value;
        });
      });
      pairEl.querySelectorAll('.ho-bundle__swatch-input').forEach(function (input) {
        var index = parseInt(input.dataset.optionIndex, 10);
        var available = isAvailable(index, input.value);
        var label = input.parentNode.querySelector('[data-ho-swatch-label]');
        if (label && !label.dataset.label) label.dataset.label = label.textContent;
        input.disabled = !available && !input.checked;
        input.parentNode.classList.toggle('is-unavailable', !available);
        if (label) label.textContent = available ? label.dataset.label : label.dataset.label + ' — ' + self.data.strings.soldOut;
      });
    },

    validate: function (pairs) {
      var strings = this.data.strings;
      var counts = {};
      var valid = true;

      pairs.forEach(function (pair) {
        if (pair.variant) counts[pair.variant.id] = (counts[pair.variant.id] || 0) + 1;
      });

      pairs.forEach(function (pair) {
        var error = '';
        if (!pair.variant) {
          error = strings.unavailable;
        } else if (!pair.variant.available) {
          error = strings.soldOut;
        } else if (pair.variant.max !== null && counts[pair.variant.id] > pair.variant.max) {
          error = strings.notEnough;
        }
        if (error) valid = false;
        if (pair.el) {
          var errEl = pair.el.querySelector('[data-ho-pair-error]');
          errEl.textContent = error;
          errEl.hidden = !error;
          pair.el.classList.toggle('has-error', !!error);
        }
      });
      return valid;
    },

    // Mirrors Shopify "Buy X get Y" behavior: the lowest-priced qualifying items are free.
    totals: function (offer, variants) {
      var prices = variants.map(function (v) { return v ? v.price : 0; }).sort(function (a, b) { return a - b; });
      var regular = prices.reduce(function (sum, p) { return sum + p; }, 0);
      var discount = prices.slice(0, offer.free).reduce(function (sum, p) { return sum + p; }, 0);
      var total = regular - discount;
      return { regular: regular, total: total, savings: discount, perPair: Math.floor(total / offer.pairs) };
    },

    // Lets other components (stock message, sticky bar) follow the bundle selection.
    announce: function (multi, variants, extra) {
      var detail = Object.assign({ multi: multi, variants: variants || [] }, extra || {});
      this.section.hoBundleState = detail; // read by scripts that load after this one
      this.section.dispatchEvent(new CustomEvent('ho:bundle-change', { detail: detail }));
    },

    setButton: function (text, enabled) {
      if (!this.btn || !this.btnText) return;
      this.btnText.textContent = text;
      this.btn.disabled = !enabled;
      this.btn.classList.toggle('disabled', !enabled);
    },

    update: function () {
      var self = this;
      var n = this.currentOfferNumber();
      var offer = this.currentOffer();

      this.el.querySelectorAll('[data-ho-offer]').forEach(function (offerEl) {
        var pairsEl = offerEl.querySelector('[data-ho-pairs]');
        var selected = offerEl.dataset.hoOffer === n;
        offerEl.classList.toggle('is-selected', selected);
        if (pairsEl) pairsEl.hidden = !selected;
      });

      var multi = !!(offer && offer.pairs > 1);
      this.section.classList.toggle('ho-bundle-mode', multi);

      if (!offer) {
        if (this.summary) this.summary.textContent = '';
        this.announce(false);
        return;
      }

      if (!multi) {
        // Single pair: keep Impulse in charge; only personalize the label.
        var variant = this.nativeVariant();
        if (variant && this.btnText) {
          var label = fill(offer.buttonLabel, { qty: 1, price: money(variant.price) }) || this.originalDefaultText;
          this.btnText.dataset.defaultText = label;
          if (!this.btn.disabled) this.btnText.textContent = label;
        }
        if (this.summary) this.summary.textContent = '';
        this.announce(false, [], { offerTitle: offer.title, pairs: 1 });
        return;
      }

      var offerEl = this.el.querySelector('[data-ho-offer="' + n + '"]');
      var pairs = this.readPairs(offerEl);
      var valid = this.validate(pairs);
      var t = this.totals(offer, pairs.map(function (p) { return p.variant; }));

      var totalEl = offerEl.querySelector('[data-ho-offer-total]');
      var compareEl = offerEl.querySelector('[data-ho-offer-compare]');
      var saveEl = offerEl.querySelector('[data-ho-offer-save]');
      var perEl = offerEl.querySelector('[data-ho-offer-per]');
      if (totalEl) totalEl.textContent = money(t.total);
      if (compareEl) compareEl.lastChild.textContent = ' ' + money(t.regular);
      if (saveEl) saveEl.textContent = this.data.strings.save + ' ' + money(t.savings);
      if (perEl) perEl.textContent = money(t.perPair) + ' ' + this.data.strings.perPair;

      if (this.summary) {
        var summary = offer.title + ': ' + offer.pairs + ' pairs, ' + money(t.total);
        if (t.savings > 0) summary += ' (' + this.data.strings.save.toLowerCase() + ' ' + money(t.savings) + ')';
        this.summary.textContent = summary;
      }

      var text = valid ? fill(offer.buttonLabel, { qty: offer.pairs, price: money(t.total) }) : (this.data.strings.chooseSizes || this.data.strings.unavailable);
      this.setButton(this.loading ? this.btnText.textContent : text, valid && !this.loading);
      this.announce(true, pairs.map(function (p) { return p.variant; }), {
        offerTitle: offer.title, pairs: offer.pairs, total: t.total, totalFormatted: money(t.total), valid: valid, loading: this.loading
      });
    },

    showMessage: function (text) {
      if (!this.message) return;
      this.message.textContent = text;
      this.message.hidden = false;
    },

    hideMessage: function () {
      if (this.message) this.message.hidden = true;
    },

    getCart: function () {
      return fetch(root + 'cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); });
    },

    addBundle: function (offer) {
      var self = this;
      if (this.loading) return; // prevents double adds from repeated clicks

      var offerEl = this.el.querySelector('[data-ho-offer="' + this.currentOfferNumber() + '"]');
      var pairs = this.readPairs(offerEl);
      if (!this.validate(pairs)) {
        this.update();
        return;
      }

      // Same variant chosen more than once becomes one line with a higher quantity.
      var grouped = {};
      var order = [];
      pairs.forEach(function (p) {
        if (!grouped[p.variant.id]) { grouped[p.variant.id] = 0; order.push(p.variant.id); }
        grouped[p.variant.id] += 1;
      });
      var items = order.map(function (id) { return { id: id, quantity: grouped[id] }; });

      this.loading = true;
      this.hideMessage();
      this.btn.classList.add('btn--loading');
      this.btn.disabled = true;

      var discountBefore = 0;

      this.getCart()
        .then(function (cart) {
          discountBefore = cart.total_discount || 0;
          return fetch(root + 'cart/add.js', {
            method: 'POST',
            credentials: 'same-origin',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
            body: JSON.stringify({ items: items })
          });
        })
        .then(function (response) {
          return response.json().then(function (body) { return { ok: response.ok, body: body }; });
        })
        .then(function (result) {
          if (!result.ok || result.body.status) {
            self.showMessage(result.body.description || self.data.strings.addError);
            return null;
          }

          // Let Impulse refresh and open the cart drawer exactly as for a normal add.
          var added = result.body.items || [];
          document.dispatchEvent(new CustomEvent('ajaxProduct:added', {
            detail: { product: added[0], items: added, addToCartBtn: self.btn }
          }));

          if (offer.free > 0) {
            return self.getCart().then(function (cart) {
              if ((cart.total_discount || 0) <= discountBefore) {
                self.showMessage(self.data.strings.discountMissing);
                if (window.console) console.warn('[Hearth & Oak bundle] No automatic discount was applied to the bundle. Check the Buy X get Y discount in Shopify Admin > Discounts.');
              }
            });
          }
          return null;
        })
        .catch(function () {
          self.showMessage(self.data.strings.addError);
        })
        .then(function () {
          self.loading = false;
          self.btn.classList.remove('btn--loading');
          self.update();
          if (document.body.classList.contains('template-cart')) location.reload();
        });
    }
  };

  window.HOBundle = {
    initAll: function () {
      document.querySelectorAll('[data-ho-bundle]:not([data-ho-ready])').forEach(function (el) {
        try { new Bundle(el); } catch (e) { if (window.console) console.error('[Hearth & Oak bundle]', e); }
      });
    }
  };

  window.HOBundle.initAll();
  document.addEventListener('DOMContentLoaded', window.HOBundle.initAll);
  document.addEventListener('shopify:section:load', window.HOBundle.initAll);
})();
